import React from 'react';
import ZarinpalTransferGeneral from '../../../containers/ZarinpalTransfersGeneral';

const ZarinpalTransfers = () => (
  <div className="dashboard-wrapper">
    <ZarinpalTransferGeneral />
  </div>
);
export default ZarinpalTransfers;
